import { create } from "zustand";

/** Board ⑤ fit preview: the library papers a draft angle's sample graded as
 *  fitting, tagged in Curate while the Add-angle sheet is open. */
interface AngleFitPreviewState {
  conceptId: string | null;
  paperIds: Set<string>;
  label: string | null;
  set: (conceptId: string, ids: Iterable<string>, label: string) => void;
  clear: () => void;
}

export const useAngleFitPreviewStore = create<AngleFitPreviewState>((set) => ({
  conceptId: null,
  paperIds: new Set(),
  label: null,
  set: (conceptId, ids, label) => set({ conceptId, paperIds: new Set(ids), label }),
  clear: () => set({ conceptId: null, paperIds: new Set(), label: null }),
}));
